import React, { ReactNode } from 'react';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

type IPropsUiTooltip = {
    title?: string | ReactNode;
}
export const UiTooltip: React.FC<IPropsUiTooltip> = (props) => {
    if (!props.title) return null;
    return (
        <Tooltip title={props.title}>
            <HelpOutlineIcon fontSize="small" />
        </Tooltip>

    )
}
export default UiTooltip;